import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { cluster, hierarchy } from 'd3-hierarchy';
export var hierarchyFunction = function hierarchyFunction(layoutFunction) {
  return function (options) {
    return function (data) {
      var _options$field = options.field,
        field = _options$field === void 0 ? 'value' : _options$field,
        nodeSize = options.nodeSize,
        separation = options.separation,
        sortBy = options.sortBy,
        _options$as = options.as,
        as = _options$as === void 0 ? ['x', 'y'] : _options$as;
      var _as = _slicedToArray(as, 2),
        x = _as[0],
        y = _as[1]; // Process root data.
      var root = hierarchy(data, function (d) {
        return d.children;
      }).sum(function (d) {
        return d[field];
      }).sort(sortBy);
      // Layout
      var c = layoutFunction();
      c.size([1, 1]);
      if (nodeSize) c.nodeSize(nodeSize);
      if (separation) c.separation(separation);
      c(root);
      var nodes = [];
      root.each(function (node) {
        node[x] = node.x;
        node[y] = node.y;
        node.name = node.data.name;
        nodes.push(node);
      });
      var edges = root.links();
      edges.forEach(function (edge) {
        edge[x] = [edge.source[x], edge.target[x]];
        edge[y] = [edge.source[y], edge.target[y]];
      });
      return {
        nodes: nodes,
        edges: edges
      };
    };
  };
};
export var Cluster = function Cluster(options) {
  return hierarchyFunction(cluster)(options);
};
Cluster.props = {};